module.exports = __webpack_public_path__ + "static/logo-eba1ce84c0ed4edf614972cdda2208bb.png";